import { render, staticRenderFns } from "./ClientCreateStepTwo.vue?vue&type=template&id=45fe832a&scoped=true&"
import script from "./ClientCreateStepTwo.vue?vue&type=script&lang=js&"
export * from "./ClientCreateStepTwo.vue?vue&type=script&lang=js&"
import style0 from "./ClientCreateStepTwo.vue?vue&type=style&index=0&id=45fe832a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fe832a",
  null
  
)

export default component.exports